import { createFileRoute } from '@tanstack/react-router';
import { ConnectSurfaceScope } from '../../features/connect/connectTelemetry';
import { ConnectTab } from '../../pages/dashboard/connect/ConnectTab';

export const Route = createFileRoute('/dashboard/connect')({ component: ConnectRoute });

function ConnectRoute() {
  return (
    <ConnectSurfaceScope surface="dashboard">
      <ConnectTab />
    </ConnectSurfaceScope>
  );
}
